module.exports = __webpack_public_path__ + "img/logo.b2c5267d.png";